export default "__VITE_ASSET__CnBZO5gX__"